"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("./hooks");

require("./Toast.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Toast = function Toast(_ref) {
  var type = _ref.type,
      from = _ref.from,
      account = _ref.account,
      message = _ref.message,
      onDismiss = _ref.onDismiss,
      onClose = _ref.onClose,
      timeout = _ref.timeout;

  var _useOpenAndDismiss = (0, _hooks.useOpenAndDismiss)(onClose, onDismiss, timeout),
      _useOpenAndDismiss2 = _slicedToArray(_useOpenAndDismiss, 1),
      isOpen = _useOpenAndDismiss2[0];

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-toast-wrapper' + (isOpen ? ' open' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-toast"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-toast-progress"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-toast-icon"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon new-' + type
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-toast-body"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "gcl-toast-title"
  }, from), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-toast-info"
  }, account && /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-toast-subtitle"
  }, account), /*#__PURE__*/_react["default"].createElement("span", {
    className: account ? undefined : 'multiline'
  }, message)))));
};

Toast.propTypes = {
  type: _propTypes["default"].oneOf(['tweet', 'chat', 'mail']).isRequired,
  from: _propTypes["default"].string.isRequired,
  account: _propTypes["default"].string,
  message: _propTypes["default"].string.isRequired,
  onDismiss: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  timeout: _propTypes["default"].number
};
Toast.defaultProps = {
  timeout: 7500
};
var _default = Toast;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/Toasts/Toast.js
// module id = 702
// module chunks = 0